// extracted by mini-css-extract-plugin
module.exports = {"notif":"notif_notif__Lm2V5","notif-icon":"notif_notif-icon__1QAU1"};